export default __webpack_public_path__ + "static/media/LSTM-Loss.e90b2b18.png";